<script lang="ts">
    import Dashboard from '../framework/components/Dashboard.svelte';
    import UserHome from "./UserHome.svelte";
    import BriefHome from './brief/BriefHome.svelte';
    import BriefBuilderHome from './brief-builder/BriefBuilderHome.svelte';
    import Profile from "../framework/components/Profile.svelte";
    import Blog from "../components/pages/Blog.svelte";
    import TeamKnowledge from "./team-knowledge/TeamKnowledge.svelte";
    import PaymentPlanHome from "./paymentplan/PaymentPlanHome.svelte";
    import PaymentPlanSelection from "../framework/components/PaymentPlanSelection.svelte";
    import InvoiceList from "../framework/components/InvoiceList.svelte";
    import InvoiceDetail from "../framework/components/InvoiceDetail.svelte";
    import TeamManagement from "./team/TeamManagement.svelte";
    import AssessmentHome from './assessment/AssessmentHome.svelte';
    import AssessmentNew from './assessment/AssessmentNew.svelte';
    import GapfinderHome from './gapfinder/GapfinderHome.svelte';
    import AiJobs from './AiJobs.svelte';
    import { auth } from '../framework/js/auth.js';
    import { get } from 'svelte/store';
    import { toast } from "../framework/js/toast.js";

    export let dashboardType: string = 'User';
    let authData: any = {};

    auth.subscribe((data: any) => {
        authData = data;
    });

    const logout = async (): Promise<void> => {
        await auth.logout();
        toast.showNotification(get(auth).success, get(auth).message);
        if (get(auth).success) {
            window.location.href = '/#/login';
            window.location.reload();
        }
    };

    interface ComponentDetail {
        component: any;
        name: string;
        icon: string;
        useModal?: boolean;
        onClick?: () => void;
        href?: string;
        className?: string;
        id?: string;
        hidden?: boolean;
        group?: string;
    }

    interface Components { [key: string]: ComponentDetail; }

    const components: Components = {
        'UserList': {
            component: UserHome,
            name: 'Dashboard',
            icon: 'th icon',
            href: '/dashboard'
        },

        // AI AGENTS
        'Assessments': {
            component: AssessmentHome,
            name: 'Illuminator',
            icon: 'icon lightbulb',
            href: '/assessments',
            group: 'AI Agents'
        },
        // Legacy BtoB wizard — kept for code history, hidden from navigation
        'Brief': {
            component: BriefHome,
            name: 'Built-to-Brief (legacy)',
            icon: 'icon pencil alternate',
            href: '/briefs',
            group: 'AI Agents',
            hidden: true
        },
        'BriefBuilder': {
            component: BriefBuilderHome,
            name: 'Built-to-Brief (BtoB)',
            icon: 'icon pencil alternate',
            href: '/brief-builder',
            group: 'AI Agents'
        },
        'Gapfinder': {
            component: GapfinderHome,
            name: 'GapFinder',
            icon: 'icon search',
            href: '/gapfinder',
            group: 'AI Agents'
        },
        'AssessmentNew': {
            component: AssessmentNew,
            name: 'New assessment',
            icon: 'icon plus',
            href: '/assessments/new',
            hidden: true
        },

        // WORKSPACE
        'Blog': {
            component: Blog,
            name: 'Learning Hub',
            icon: 'icon blog',
            href: '/learning',
            group: 'Workspace'
        },
        'TeamKnowledge': {
            component: TeamKnowledge,
            name: 'Team Knowledge',
            icon: 'icon book',
            href: '/team-knowledge',
            group: 'Workspace'
        },
        'AiJobs': {
            component: AiJobs,
            name: 'AI Processes',
            icon: 'icon cogs',
            href: '/ai-processes',
            group: 'Workspace'
        },

        // ACCOUNT
        'Team': {
            component: TeamManagement,
            name: 'My Team',
            icon: 'icon users',
            href: '/team',
            group: 'Account'
        },
        'PaymentPlan': {
            component: PaymentPlanHome,
            name: 'My Plan',
            icon: 'icon credit card',
            href: '/payment-plan',
            group: 'Account'
        },
        'Profile': {
            component: Profile,
            name: 'My Profile',
            icon: 'icon user outline',
            href: '/profile',
            group: 'Account'
        },

        // hidden (accessed from within other pages)
        'PaymentPlanSelect': {
            component: PaymentPlanSelection,
            name: 'Choose Plan',
            icon: 'icon credit card',
            href: '/payment-plans',
            hidden: true
        },
        'Invoices': {
            component: InvoiceList,
            name: 'Invoices',
            icon: 'icon file alternate outline',
            href: '/invoices',
            hidden: true
        },
        'InvoiceDetail': {
            component: InvoiceDetail,
            name: 'Invoice',
            icon: 'icon file alternate outline',
            href: '/invoices/:uuid',
            hidden: true
        },

        'Logout': {
            component: null,
            name: 'Logout',
            icon: 'icon sign out',
            onClick: logout,
            className: 'item'
        }
    };
</script>

<Dashboard {components} bind:dashboardType={dashboardType} />
